<template>
    <div class="notice-create-page editor-wrapper px-4 py-4 md:px-5">
        <div class="mx-auto space-y-5">
            <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div class="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
                    <div>
                        <p class="text-[15px] font-semibold text-slate-900">
                            {{ noticePage.noticeUpdate ? "공지사항 수정" : "공지사항 등록" }}
                        </p>
                        <p class="mt-1 text-sm text-slate-500">공지사항 제목과 내용을 입력합니다.</p>
                    </div>

                    <span class="result-chip">
                        {{ noticePage.noticeUpdate ? "수정 모드" : "등록 모드" }}
                    </span>
                </div>
            </section>

            <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div class="mb-4 border-b border-slate-200 pb-4">
                    <p class="text-base font-semibold text-slate-900">기본 정보</p>
                    <p class="mt-1 text-sm text-slate-500">목록에 노출될 공지사항 제목입니다.</p>
                </div>

                <label class="form-field">
                    <span class="form-label">제목</span>
                    <input
                        v-model="noticePage.noticeList.title"
                        type="text"
                        maxlength="50"
                        placeholder="제목을 입력하세요."
                        class="form-control"
                    />
                </label>
            </section>

            <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div class="mb-4 border-b border-slate-200 pb-4">
                    <p class="text-base font-semibold text-slate-900">내용</p>
                    <p class="mt-1 text-sm text-slate-500">공지사항 상세 내용을 작성합니다.</p>
                </div>

                <div class="editor-card">
                    <BagicEditor v-model="noticePage.noticeList.content"></BagicEditor>
                </div>
            </section>

            <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                    <p class="text-sm text-slate-500">작성한 내용은 저장 후 공지사항 목록에서 확인할 수 있습니다.</p>
                    <div class="flex flex-col gap-3 sm:flex-row">
                        <button type="button" class="secondary-button" @click="noticePage.goBack">돌아가기</button>
                        <button
                            v-if="!noticePage.noticeUpdate"
                            type="button"
                            class="primary-button"
                            @click="noticePage.registNotice"
                        >
                            등록
                        </button>
                        <button
                            v-if="noticePage.noticeUpdate"
                            type="button"
                            class="primary-button"
                            @click="noticePage.registNotice"
                        >
                            수정
                        </button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import { useRoute } from "vue-router";
import BagicEditor from "@/components/BagicEditor.vue";
import { reactive, onMounted } from "vue";
import axios from "@/plugins/axios.js";

export default {
    components: {
        BagicEditor,
    },
    setup() {
        const route = useRoute();

        const noticePage = reactive({
            noticeList: {
                content: "",
                idxLeSiteMain: "",
                idxNotice: "",
                title: "",
                viewCount: 0,
            },

            noticeUpdate: false,

            // 공지사항 조회
            getRegistNotice() {
                noticePage.noticeList.idxNotice = route.query.idxNotice;
                if (
                    noticePage.noticeList.idxNotice &&
                    noticePage.noticeList.idxNotice !== "0"
                ) {
                    const params = {
                        idxNotice: noticePage.noticeList.idxNotice,
                    };
                    axios.get(`/admin/notice`, { params }).then(function (res) {
                        if (res.data.success) {
                            noticePage.noticeList = res.data.data;
                            noticePage.noticeUpdate = true;
                        } else {
                            // 처리 실패 시의 동작
                        }
                    });
                }
            },

            // 공지사항 등록
            registNotice() {
                noticePage.noticeList.idxLeSiteMain = route.query.idxLeSiteMain;
                noticePage.noticeList.idxNotice = route.query.idxNotice;
                let params = noticePage.noticeList;
                axios.post("/admin/notice", params, {}).then(function (res) {
                    if (res.data.success) {
                        if (noticePage.noticeUpdate) {
                            alert("수정되었습니다.");
                            window.history.back();
                        } else if (noticePage.noticeList.idxNotice !== "0") {
                            alert("등록되었습니다.");
                            window.history.back();
                        }
                    } else {
                        //alert(res.data.message);
                    }
                    // listPage.is_loader = false;
                });
            },

            goBack() {
                window.history.back();
            },
        });

        onMounted(() => {
            noticePage.getRegistNotice();
        });

        return {
            noticePage,
        };
    },
};
</script>
<style scoped>
.notice-create-page {
    min-height: 100%;
    background:
        radial-gradient(circle at top left, rgba(226, 232, 240, 0.65), transparent 32rem),
        linear-gradient(180deg, #f8fafc 0%, #ffffff 42%);
}

.result-chip {
    display: inline-flex;
    align-items: center;
    border-radius: 9999px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    padding: 0.4rem 0.8rem;
}

.form-field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-label {
    font-size: 0.75rem;
    font-weight: 700;
    color: #64748b;
}

.form-control {
    height: 2.875rem;
    width: 100%;
    border: 1px solid #cbd5e1;
    border-radius: 0.75rem;
    background-color: #fff;
    padding: 0.7rem 0.9rem;
    font-size: 0.95rem;
    color: #0f172a;
    outline: none;
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;
}

.form-control:focus {
    border-color: #94a3b8;
    box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.editor-card {
    overflow: hidden;
    border-radius: 0.75rem;
    border: 1px solid #e2e8f0;
}

.primary-button,
.secondary-button {
    display: inline-flex;
    min-height: 2.875rem;
    align-items: center;
    justify-content: center;
    border-radius: 0.75rem;
    padding: 0.7rem 1.1rem;
    font-size: 0.95rem;
    font-weight: 700;
    transition:
        background-color 0.2s ease,
        border-color 0.2s ease,
        color 0.2s ease;
}

.primary-button {
    background: #2563eb;
    color: #fff;
}

.primary-button:hover {
    background: #1d4ed8;
}

.secondary-button {
    border: 1px solid #cbd5e1;
    background: #f8fafc;
    color: #475569;
}

.secondary-button:hover {
    background: #f1f5f9;
}

.editor-wrapper :deep(.tox) {
    height: 1000px !important;
}
</style>
